import { Link } from "react-router-dom";
import { Coffee } from "lucide-react";
import { openConsent } from "./CookieConsent";

const PAYPAL = "https://www.paypal.com/donate/?business=fabriziosasso93%40gmail.com&currency_code=EUR&item_name=Offri%20un%20caff%C3%A8%20a%20Social%20Betting";

const Support = () => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 rounded-xl border border-amber-500/30 bg-amber-500/5 px-4 py-3" data-testid="footer-support">
    <p className="text-slate-300">Sito 100% indipendente, tutti i costi sono a carico dell'admin. Se ti diverti, supporta il team offrendogli un caffè.</p>
    <a href={PAYPAL} target="_blank" rel="noopener noreferrer" data-testid="footer-coffee-link"
      className="shrink-0 inline-flex items-center gap-2 h-10 px-5 rounded-full bg-amber-400 hover:bg-amber-300 text-[#0A0D14] font-bold transition-colors">
      <Coffee size={16} /> Offri un caffè con PayPal
    </a>
  </div>
);

export const LegalFooter = () => (
  <footer className="border-t border-[#26334D]" data-testid="legal-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 py-6 space-y-4 text-xs text-slate-400">
      <Support />
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <span className="h-8 w-8 shrink-0 rounded-full border-2 border-red-500 text-red-400 grid place-items-center font-bold" data-testid="footer-18plus">18+</span>
          <span>Gioco gratuito a punti virtuali, riservato ai maggiorenni. Nessuna scommessa in denaro, nessuna vincita in denaro.</span>
        </div>
        <nav className="flex flex-wrap gap-x-5 gap-y-2 font-mono uppercase tracking-widest">
          <Link to="/regolamento" className="text-emerald-400 hover:underline" data-testid="footer-rules-link">Regolamento</Link>
          <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/termini" className="hover:text-white" data-testid="footer-terms-link">Termini</Link>
          <button type="button" onClick={openConsent} className="uppercase tracking-widest hover:text-white" data-testid="footer-manage-cookies">Gestisci cookie</button>
        </nav>
      </div>
    </div>
  </footer>
);
